import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import type { CommissionTrendData } from '../../types/dashboard.types';

interface CommissionTrendChartProps {
  data: CommissionTrendData[];
}

export const CommissionTrendChart: React.FC<CommissionTrendChartProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold mb-4 text-gray-900">Commission Trend</h3>
        <div className="h-[300px] flex items-center justify-center text-gray-500">
          No commission data available
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold mb-4 text-gray-900">Commission Trend</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="date"
            tick={{ fontSize: 12 }}
            tickFormatter={(date) => new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
          />
          <YAxis
            tick={{ fontSize: 12 }}
            tickFormatter={(value) => `$${value.toLocaleString()}`}
          />
          <Tooltip
            formatter={(value: any) => `$${Number(value).toLocaleString()}`}
          />
          <Legend />
          <Line
            type="monotone"
            dataKey="salesCommission"
            stroke="#3b82f6"
            strokeWidth={2}
            name="Sales Commission"
            dot={{ r: 3 }}
          />
          <Line
            type="monotone"
            dataKey="overrides"
            stroke="#10b981"
            strokeWidth={2}
            name="Overrides"
            dot={{ r: 3 }}
          />
          <Line
            type="monotone"
            dataKey="bonuses"
            stroke="#f59e0b"
            strokeWidth={2}
            name="Bonuses"
            dot={{ r: 3 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
